<template>
  <div>
  <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li class="active">會員條款</li>
            </ol>
            <div class="row">
                <div class="col-sm-2">
                    <div class="aside_menu">
                        <h4 class="title">會員條款</h4>
                        <ul class="list-unstyled">
                            <li class="item"><a href="/privacy">隱私權政策</a></li>
                            <li class="item"><a href="/member_policy">會員條款</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-10">
                    <h3 class="title hidden-xs hidden-sm">會員條款</h3>
                    <div class="editor">
                      <p>
                        愛幫您股份有限公司之會員，以下簡稱 i80 會員， i80 會員享有各合作商家經營的商品及服務優惠，及經營組織會員之權利，以下為不同會員級別的權利與義務
                      </p>
                      <p>
                        一、一般會員：<br/>
                        1、免費註冊享終身折扣優惠並回饋 12 ％ 點數<br/>
                        2、會員取得之點數僅供愛幫您股份有限公司平台內使用
                      </p>
                      <br/>
                      <p>
                        二、分享會員：<br/>
                        １、必須符合會員身分。<br/>
                        ２、必須參加經營者會員培訓。<br/>
                        ３、組織回饋的 50％ 產品，50 ％點數，個人必須有消費方可領取點數。<br/>
                        ４、每月必須達，消費 500 點以上(因消費結算方式有點數上的落差，請至 -> 回饋金查詢 -> 總點數，計算結果為準)，才能具有維持經營組織權，若未達消費門檻，原本推薦組織將不再列入您的會員帳號下。<br/>
                      </p>
                      <br/>
                      <p>
                        三、以上會員資格公司保有修改條款權利
                      </p>
                      <br/>
                      <p>
                        四、一般會員以及分享會員，若違反愛幫您之規定或影響公司商譽等，愛幫您股份有限公司有權立即停止該帳戶、組織以及福利。
                      </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data () {
    return {
      rowData: {}
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// MemberPolicy.vue?88cd1a02